

export default function Section6() {
  return (

    <section class="digital-marketing-section py-8 md:py-10 bg-[#F5F5F5]">
      <div class="container-1280 section5-container  mx-auto w-full px-[15px] md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <div class="heading text-center mx-auto">
          <h1 class="text-[24px] md:text-4xl font-bold mb-4 leading-normal">Graphic Design Services</h1>
          <p class="text-[16px] font-open text-[#373737] mt-0 lg:mt-0 mb-5">
            Graphic design is an essential part of building a strong brand. At Mean3, we specialize in
            graphic design services. We assist businesses in establishing a strong and
            professional visual identity. We create designs that look great and connect well with your
            audience. Every project we take on is rooted in strategy, visual storytelling, and market
            relevance. We assist brands of all sizes, from new startups to well-known companies. Our
            impactful design work creates trust and recognition.
          </p>
        </div>
      </div>

    </section>


  );
}